module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/allotment-of-electors-desktop.svg?v=7c540dcf";